import createLucideIcon from '../createLucideIcon';

const AlignLeft = createLucideIcon('AlignLeft', [
  ['line', { x1: '21', x2: '3', y1: '6', y2: '6', key: '1fp77t' }],
  ['line', { x1: '15', x2: '3', y1: '12', y2: '12', key: 'v6grx8' }],
  ['line', { x1: '17', x2: '3', y1: '18', y2: '18', key: '1awlsn' }],
]);

export default AlignLeft;
